(function () {
  function initHero(root) {
    if (!root || root.dataset.nutrioHeroReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-nutrio-slide]'));
    if (slides.length <= 1) return;

    root.dataset.nutrioHeroReady = 'true';

    const dots = Array.from(root.querySelectorAll('[data-nutrio-dot]'));
    const prevBtn = root.querySelector('[data-nutrio-prev]');
    const nextBtn = root.querySelector('[data-nutrio-next]');
    const autoRotate = root.dataset.autoRotate === 'true';
    const speed = Math.max(3, parseInt(root.dataset.speed || '5', 10)) * 1000;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let index = 0;
    let timer = null;

    function setActive(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, i) {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function next() {
      setActive(index + 1);
    }

    function prev() {
      setActive(index - 1);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoRotate || reduceMotion || slides.length < 2) return;
      timer = setInterval(next, speed);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        start();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        start();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        setActive(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    setActive(0);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-nutrio-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const hero = event.target.querySelector('[data-nutrio-hero]');
    if (hero) {
      hero.dataset.nutrioHeroReady = 'false';
      initHero(hero);
    }
  });
})();
